module.exports = __webpack_public_path__ + "media/images/short-page-c5140a265013f6fca6f1460c6c5c1fee.png";